import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'
import { AuthService } from '.././auth.service';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.css']
})
export class RedirectComponent implements OnInit {
  loader = false;
  tokenValue: any;
  constructor(private route: ActivatedRoute, private authService: AuthService, private router: Router,
    private cookieService: CookieService) {
    this.tokenValue = this.cookieService.get(environment.aeroTokenProp);
  }

  ngOnInit(): void {
    this.loader = true;
    this.route.queryParams.subscribe(params => {
      const code = params && params['code'];
      if (code) {
        this.authService.exchangeCodeForToken(code).subscribe((response) => {
          const access_token = response?.data?.accessToken;
          localStorage.setItem('access_token', access_token);
          setTimeout(() => {
            this.tokenValue = this.cookieService.get(environment.aeroTokenProp);
            //send the access token to user info api
            if (this.tokenValue && access_token) {
              localStorage.setItem('AeroJwtToken', this.tokenValue);
              this.callApgAccess(access_token);
            } else {
              this.loader = false;
              this.unAuthorizedCall();
            }
          }, 2000);
        }, error => {
          this.loader = false;
          Swal.fire({
            title: 'Error',
            text: 'Please try after sometime!',
            icon: 'error',
            focusConfirm: false,
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonText: 'OK'
          }).then((e: any) => {
            window.location.href = environment.ssoUrl;
          })
        })
      }
    });
  }

  callApgAccess(access: any) {
    this.authService.getApgAccessToken(access).subscribe((data: any) => {
      if (data?.data) {
        this.callReAuthorize(access, data?.data?.accessToken);
        this.loader = false;
      }
    }, error => {
      this.loader = false;
      Swal.fire({
        title: 'Error',
        text: 'Please try after sometime!',
        icon: 'error',
        focusConfirm: false,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: 'OK'
      }).then((e: any) => {
        window.location.href = environment.ssoUrl;
      })
    });
  }

  callReAuthorize(access: any, acc: any) {
    this.authService.getApgAuthorization(access, acc).subscribe((authorize: any) => {
      if (authorize?.data) {
        const userPermissions = authorize?.data;
        localStorage.setItem('authUserId', userPermissions?.userId);
        const hasPermission = true;
        this.authService.setPermissionStatus(hasPermission);
        const page = localStorage.getItem('pageName');
        if (page == "report-discrep") {
          this.loader = false;
          this.router.navigate(['/report-discrep']);
        } else if (page == "search-discrep") {
          if ((userPermissions?.licDiscrepancy && environment.licensed) || (userPermissions?.nonLicDiscrepancy && !environment.licensed)) {
            this.loader = false;
            this.router.navigate(['/search-discrep']);
          } else {
            this.loader = false;
            this.unAuthorizedCall();
          }
        }
      } else {
        this.loader = false;
        this.unAuthorizedCall();
      }
    }, error => {
      this.loader = false;
      Swal.fire({
        title: 'Error',
        text: 'Please try after sometime!',
        icon: 'error',
        focusConfirm: false,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: 'OK'
      }).then((e: any) => {
        window.location.href = environment.ssoUrl;
      })
    });
  }

  unAuthorizedCall() {
    Swal.fire({
      title: 'Oops!',
      icon: 'warning',
      html:
        '<p style="margin-bottom: 24px;">Looks like something went wrong. Please click below link to redirect now back to Tech pubs ' +
        `<b><a href="${environment.ssoUrl}" style="cursor: pointer;outline: none !important;border: 0; color: blue;">Techpubs Portal</a></b></p>`,
      focusConfirm: false,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: 'OK'
    });
  }
}

